<template>
  <!-- 订单概要 -->
  <div>
    <div class="container" style="box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px">
      <e-search
        :count="searchData.count"
        :data="searchData.data"
        :field-list="searchData.fieldList"
        :list-type-info="searchData.listTypeInfo"
        @handleFocus="handleFocus"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      />
    </div>

    <div class="container">
      <div class="handle-wrapper">
        <eui-btn v-debounce="exportSummary" type="secondary" style="margin-right: 10px">导出订单概要</eui-btn>
        <el-tooltip class="item" effect="dark" content="根据筛选条件导出信息" placement="top">
          <span class="right-icon">?</span>
        </el-tooltip>
      </div>
      <tableList
        ref="tableRef"
        :loading="false"
        row-key="vocabularyId"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #purchaseCompanyAbbr="slot">
          <e-tooltip :content="slot.scope.row.purchaseCompanyAbbr" :set-length="14" />
        </template>
        <template #purchaseCompany="slot">
          <e-tooltip :content="slot.scope.row.purchaseCompany" :set-length="14" />
        </template>
        <template #supplierCompany="slot">
          <e-tooltip :content="slot.scope.row.supplierCompany" :set-length="14" />
        </template>
        <template #receiveAddress="slot">
          <e-tooltip :content="slot.scope.row.receiveAddress" :set-length="16" />
        </template>
        <template #remark="slot">
          <e-tooltip :content="slot.scope.row.remark" :set-length="16" />
        </template>
        <template #categoryName="slot">
          <eui-tooltip-over
                  :line="2"
                  :content="slot.scope.row.categoryName"
                  :tooltipStyle="{ width: '160px', fontsize: '12px' }"
          >
            <div>{{ slot.scope.row.categoryName }}</div>
          </eui-tooltip-over>
        </template>
        <template #operation="slot">
          <eui-link lighten font-size="12" @click="handleOrderDetails(slot.scope.row)">明细</eui-link>
          <eui-link lighten font-size="12" style="margin-left: 10px" @click="handleOperationLog(slot.scope.row)">
            操作日志
          </eui-link>
        </template>
      </tableList>

      <div class="pagination flex-end">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <div class="margin-l20">
          交易金额：
          <span style="color: #ef4c56">{{ totalAmount }}</span>
          元
        </div>
      </div>
    </div>
    <!--订单明细弹框-->
    <order-detail-dialog
      v-if="orderDetailsVisible"
      :detail-data="detailData"
      :order-details-visible="orderDetailsVisible"
      @closeDialog="closeDialog"
    />
    <!--订单操作弹框-->
    <order-operation-log-dialog
      v-if="orderOperationLogVisible"
      :log-data="logData"
      :order-operation-log-visible="orderOperationLogVisible"
      @closeDialog="closeDialog"
    />
    <!--采购商 和 供应商  的 弹框-->
    <query-name-dialog
      v-if="chooseVisible"
      :choose-visible="chooseVisible"
      :company-id-list="companyIdList"
      :purchase-company-info="purchaseCompanyInfo"
      :purchase-company-id-list="queryData.purchaseCompanyIdList"
      :supplier-company-info="supplierCompanyInfo"
      :supplier-company-id-list="queryData.supplierCompanyIdList"
      :select-name-flag="selectNameFlag"
      @closeDialog="closeDialog"
      @handleQueryCompany="handleQueryCompany"
    />
    <!--采购商的弹框-->
    <query-purchase-company-dialog
            v-if="queryPurchaseCompanyVisible"
            :queryPurchaseCompanyVisible.sync="queryPurchaseCompanyVisible"
            :purchaseCompanyInfo="purchaseCompanyInfo"
            @confirmPurchaseCompany="confirmPurchaseCompany"
    />

  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import tableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/order';
import eTooltip from '@/modules/projectA/components/common/e-tooltip';
import utils, { formatDate, fileExportResponseError } from '@/modules/projectA/utils/utils';
import orderDetailDialog from './common/orderDetailDialog';
import orderOperationLogDialog from './common/orderOperationLogDialog';
import queryNameDialog from './common/queryNameDialog';
import queryPurchaseCompanyDialog from './common/queryPurchaseCompanyDialog';

export default {
  name: 'OrderSummary',
  components: {
    eSearch,
    tableList,
    orderDetailDialog,
    orderOperationLogDialog,
    eTooltip,
    queryNameDialog,
    queryPurchaseCompanyDialog
  },
  data() {
    return {
      totalAmount: 0,
      queryData: {
        purchaseCompanyIdList: null,
        orderNo: null,
        orderStatusList: null,
        memberRealName: null,
        supplierCompanyIdList: null,
        startTime: null,
        endTime: null,
        submitTime: null,
        systemSource: null,
        invoiceNode: null,
        isDoc: null,
        payment: null,
        invoiceMode: null,
        orderSourceList: null,
        isOnlinePay: null,
        pageNum: 1,
        pageSize: 10,
        electronicInvoiceFlag: null,
        startAmount: null,
        endAmount: null,
        purchaseCompanySource: null,
      },
      pageTotal: 0,
      orderDetailsVisible: false, // 订单明细
      orderOperationLogVisible: false, // 订单操作
      chooseVisible: false, // 采购商和供应商选择的弹框
      selectNameFlag: '', // 区别 是 采购商 还是 供应商的 字段
      companyIdList: [], // 采购商 或者 供应商默认选中得id集合
      purchaseCompanyInfo: [], // 采购商默认选中 的所有信息
      supplierCompanyInfo: [], // 供应商默认选中 的所有信息
      queryPurchaseCompanyVisible: false,//采购商选择得弹框
      logData: {
        orderNo: null,
        purchaseCompanyId: null,
      },
      detailData: {
        orderId: '',
        purchaseCompanyId: '',
      },
      searchData: {
        count: 6,
        data: {
          purchaseCompanyIdList: null,
          orderNo: null,
          orderStatusList: null,
          memberRealName: null,
          supplierCompanyIdList: null,
          startTime: null,
          endTime: null,
          submitTime: null,
          systemSource: null,
          invoiceNode: null,
          isDoc: null,
          payment: null,
          invoiceMode: null,
          orderSourceList: null,
          electronicInvoiceFlag: null,
          startAmount: null,
          endAmount: null,
          purchaseCompanySource: null,
        },
        fieldList: [
          {
            label: '采购商',
            type: 'dialog',
            value: 'purchaseCompanyIdList',
            placeholder: '请输入采购商',
            disabled: false,
          },
          {
            label: '订单编号',
            type: 'input',
            value: 'orderNo',
            placeholder: '请输入订单编号',
          },
          {
            label: '订单状态',
            type: 'select',
            multiple: 'multiple',
            value: 'orderStatusList',
            collapseTags: true,
            list: 'statusList',
            placeholder: '请选择订单状态',
          },
          {
            label: '下单人',
            type: 'input',
            value: 'memberRealName',
            placeholder: '请输入下单人',
          },
          {
            label: '开票节点',
            type: 'select',
            value: 'invoiceNode',
            list: 'invoicingNodeList',
            placeholder: '请输入开票节点',
          },
          {
            label: '供应商',
            type: 'dialog',
            value: 'supplierCompanyIdList',
            placeholder: '请输入供应商',
          },
          {
            label: '下单时间',
            type: 'date',
            value: 'submitTime',
            dateType: 'datetimerange',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            defaultTime: ['00:00:00', '23:59:59'],
            placeholder: '请输入下单时间',
          },
          {
            label: '结算方式',
            type: 'select',
            value: 'isDoc',
            list: 'settlementMethodList',
            placeholder: '请选择结算方式',
          },
          {
            label: '付款方式',
            type: 'select',
            value: 'payment',
            list: 'paymentMethodList',
            placeholder: '请选择结算方式',
          },
          {
            label: '开票方式',
            type: 'select',
            value: 'invoiceMode',
            list: 'invoicingMethodList',
            placeholder: '请选择开票方式',
          },
          {
            label: '发票类型',
            type: 'select',
            value: 'electronicInvoiceFlag',
            list: 'electronicInvoiceFlagList',
            placeholder: '请选择发票类型',
          },
          {
            label: '业务来源',
            type: 'select',
            value: 'systemSource',
            list: 'businessSourceList',
            placeholder: '请选择业务来源',
          },
          {
            label: '订单流程',
            type: 'select',
            value: 'orderSourceList',
            multiple: 'multiple',
            collapseTags: true,
            list: 'orderProcessList',
            placeholder: '请选择订单流程',
          },
          {
            label: '订单金额',
            type: 'numRange',
            value1: 'startAmount',
            value2: 'endAmount',
            rangeWidth: 'min-width',
            placeholder: '请输入订单金额',
          },
          {
            label: '企业来源',
            type: 'select',
            value: 'purchaseCompanySource',
            list: 'purchaseCompanySourceList',
            placeholder: '请选择企业来源',
          },
        ],
        listTypeInfo: {
          // 301易派客,302百望云
          purchaseCompanySourceList: [
            { name: '全部', id: null },
            { name: '易派客', id: 301 },
            { name: '百望云', id: 302 },
            {name: '合金不锈专区', id: 4},
          ],
          statusList: [
            { name: '待供应商确认', id: 17 },
            { name: '待采购商确认', id: 18 },
            { name: '待审批', id: 12 },
            { name: '待付款', id: 21 }, // 传[21,22,103]
            { name: '待发货', id: 31 }, // 传[31,32]
            { name: '待收货', id: 4 },
            { name: '交易完成', id: 6 },
            { name: '已取消', id: 7 },
            { name: '取消中', id: 71 },
            { name: '变更中', id: 72 },
            { name: '待付尾款', id: 102 },
            { name: '溢装待付款', id: 103 },
          ],
          invoicingNodeList: [
            { name: '全部', id: null },
            { name: '下单后立即开票', id: 2 },
            { name: '与其他订单合并开票', id: 3 },
          ],
          settlementMethodList: [
            { name: '全部', id: null },
            { name: '款到发货', id: 0 },
            { name: '货到付款', id: 1 },
          ],
          paymentMethodList: [
            { name: '全部', id: null },
            { name: '直接支付', id: 0 },
            { name: '担保支付', id: 1 },
            { name: '网银支付', id: 3 },
            { name: '扫码支付', id: 4 },
            { name: '现金', id: 103 },
            { name: '网银转账', id: 101 },
            { name: '承兑汇票', id: 102 },
            { name: '支票', id: 104 },
          ],
          invoicingMethodList: [
            { name: '全部', id: null },
            { name: '一票制', id: 1 },
            { name: '两票制', id: 2 },
          ],
          // 业务来源
          businessSourceList: [
            { name: '全部', id: null },
            { name: '易派客2.0', id: 2 },
            { name: 'MRO', id: 3 },
            {name: '合金不锈', id: 4},
          ],
          electronicInvoiceFlagList: [
            { name: '全部', id: null },
            { name: '电子发票', id: 1 },
            { name: '纸质发票', id: 0 },
          ],
          orderProcessList: [
            { name: '商品详情页', id: 1 },
            { name: '购物车', id: 2 },
            { name: '一体化', id: 3 },
            { name: '询比价', id: 4 },
            { name: '招标订单', id: 9 },
            { name: '外部系统订单', id: 5 },
            { name: '需求计划', id: 6 },
            { name: '采购计划', id: 7 },
            { name: '清单采购下单', id: 8 },
            { name: '融合方案', id: 31 },
            { name: '标品比价', id: 21 },
            {name: '合金不锈-商详页', id: 11},
            {name: '合金不锈-购物车', id: 12},
            {name: '合金不锈-询比价订单', id: 13},
          ],
        },
        /* :btn-style="searchData.btnStyle"
        btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }], */
      },
      tableData: [],
      tableLabel: [
        {
          label: '订单编号',
          param: 'orderNo',
          align: 'center',
          width: '170px',
          fixed: 'left',
        },
        {
          label: '订单状态',
          param: 'orderStatusDesc',
          width: '120px',
          align: 'center',
        },
        {
          label: '采购商简称',
          param: 'purchaseCompanyAbbr',
          // slot: 'purchaseCompanyAbbr',
          width: '260px',
          align: 'center',
        },
        {
          label: '采购商全称',
          param: 'purchaseCompany',
          // slot: 'purchaseCompany',
          width: '300px',
          align: 'center',
        },
        /* {
          label: '采购商IP地址',
          param: 'purchaseOperatorIp',
          width: '120px',
          align: 'center',
        }, */
        {
          label: '下单部门',
          param: 'orgShortName',
          align: 'center',
          width: '120px',
        },
        {
          label: '下单人',
          param: 'memberRealName',
          width: '120px',
          align: 'center',
        },
        {
          label: '下单人账号',
          param: 'memberName',
          width: '120px',
          align: 'center',
        },
        {
          label: '订单金额',
          param: 'needPay',
          width: '120px',
          align: 'center',
        },
        {
          label: '运费',
          param: 'shippingCost',
          align: 'center',
        },
        {
          label: '易权通转让',
          param: 'otherNeedPay',
          width: '90px',
          align: 'center',
        },
        {
          label: '商品类别',
          param: 'categoryName',
          align: 'center',
          width: '180px',
          slot:'categoryName'
        },
        {
          label: '供应商',
          param: 'supplierCompany',
          // slot: 'supplierCompany',
          width: '300px',
          align: 'center',
        },
        /* {
          label: '供应商IP地址',
          param: 'supplierOperatorIp',
          width: '120px',
          align: 'center',
        }, */
        {
          label: '下单时间',
          param: 'submitTime',
          width: '140px',
          align: 'center',
        },
        {
          label: '要求到货日期',
          param: 'arriveTimeTxt',
          width: '140px',
          align: 'center',
        },
        {
          label: '付款时间',
          param: 'payTime',
          width: '140px',
          align: 'center',
        },
        {
          label: '供应商确认时间',
          param: 'supplierConfirmTime',
          width: '140px',
          align: 'center',
        },
        {
          label: '审批时间',
          param: 'approveTime',
          width: '140px',
          align: 'center',
        },
        {
          label: '发货时间',
          param: 'deliverTime',
          width: '140px',
          align: 'center',
        },
        {
          label: '收货时间',
          param: 'receiveTime',
          width: '140px',
          align: 'center',
        },
        {
          label: '评价时间',
          param: 'purcScoreTime',
          width: '140px',
          align: 'center',
        },
        {
          label: '结算类型',
          param: 'settleTypeDesc',
          align: 'center',
        },
        {
          label: '付款方式',
          param: 'paymentDesc',
          align: 'center',
        },
        {
          label: '开票节点',
          param: 'invoiceNodeDesc',
          width: '130px',
          align: 'center',
        },
        {
          label: '开票方式',
          param: 'invoiceModeCodeDesc',
          align: 'center',
        },
        {
          label: '发票类型',
          param: 'electronicInvoiceFlag',
          align: 'center',
          render: (item) => {
            let str = '';
            if (parseInt(item.electronicInvoiceFlag, 10) === 1) {
              str = '电子发票';
            } else {
              str = '纸质发票';
            }
            return str;
          },
        },
        {
          label: '配送方式',
          param: 'shipmentTypeDesc',
          align: 'center',
          width: '100px',
        },
        /* {
          label: '终端标识',
          param: 'terminal',
          align: 'center',
          width: '110px',
        }, */
        {
          label: '业务来源',
          param: 'businessFrom',
          width: '110px',
          align: 'center',
        },
        {
          label: '订单流程',
          param: 'businessFlow',
          width: '100px',
          align: 'center',
        },
        /* {
          label: '集成标识',
          param: 'integrated',
          width: '110px',
          align: 'center',
        }, */
        {
          label: '溢装标识',
          param: 'hasOverShipmentDesc',
          align: 'center',
        },
        {
          label: '收货人',
          param: 'receiveName',
          align: 'center',
        },
        {
          label: '联系方式',
          param: 'receivePhone',
          width: '110px',
          align: 'center',
        },
        {
          label: '收货地址',
          param: 'receiveAddress',
          slot: 'receiveAddress',
          width: '130px',
          align: 'center',
        },
        {
          label: '备注',
          param: 'remark',
          slot: 'remark',
          width: '130px',
          align: 'center',
        },

        {
          label: '操作',
          param: 'vocabularyName',
          align: 'center',
          width: '140px',
          slot: 'operation',
          fixed: 'right',
        },
      ],
    };
  },
  watch: {
    $router: {
      handler(to, form) {
        console.log(to, form);
      },
    },
  },
  mounted() {
    const epecKanBanParams = JSON.parse(localStorage.getItem('epecKanBanParams')) || {};
    if (Object.keys(epecKanBanParams).length > 0) {
      this.searchData.fieldList[0].disabled = true;
      const { companyId } = epecKanBanParams;
      this.queryData.purchaseCompanyIdList = [companyId];
    }
    this.operatorOrderList();
  },
  // 适配易派客看板跳转
  destroyed() {
    localStorage.removeItem('epecKanBanParams');
  },
  methods: {
    confirmPurchaseCompany(val) {
      let companyNameList = val.map((item) => item.companyName).toString();
      if (companyNameList && companyNameList.length > 15) {
        companyNameList = `${companyNameList.substring(0, 14)}...`;
      }
      this.companyIdList = val.map((item) => item.companyId);
      if (companyNameList.length > 0) {
        this.searchData.data.purchaseCompanyIdList = companyNameList;
        this.queryData.purchaseCompanyIdList = this.companyIdList;
        this.purchaseCompanyInfo = val;
      } else {
        this.searchData.data.purchaseCompanyIdList = null;
        this.queryData.purchaseCompanyIdList = null;
        this.purchaseCompanyInfo = [];
      }

    },
    async exportSummary() {
      const time = formatDate(new Date(), 'yyyyMMdd');
      const res = await api.dataOperationOrderExportOrder(this.queryData);
      if (res.type === 'application/json') {
        fileExportResponseError(res);
      } else {
        utils.downFile(res, `订单概要信息_${time}`, '.xls');
      }
    },
    // 采购商 和 供应商 的 多选
    handleQueryCompany(val) {
      let companyNameList = val.map((item) => item.companyName).toString();
      if (companyNameList && companyNameList.length > 15) {
        companyNameList = `${companyNameList.substring(0, 14)}...`;
      }
      this.companyIdList = val.map((item) => item.companyId);
      if (this.companyIdList.length > 0) {
        if (this.selectNameFlag === 'purchaseCompanyIdList') {
          this.searchData.data.purchaseCompanyIdList = companyNameList;
          this.queryData.purchaseCompanyIdList = this.companyIdList;
          this.purchaseCompanyInfo = val;
        } else if (this.selectNameFlag === 'supplierCompanyIdList') {
          this.searchData.data.supplierCompanyIdList = companyNameList;
          this.queryData.supplierCompanyIdList = this.companyIdList;
          this.supplierCompanyInfo = val;
        }
      } else if (this.selectNameFlag === 'purchaseCompanyIdList') {
        this.searchData.data.purchaseCompanyIdList = null;
        this.queryData.purchaseCompanyIdList = null;
        this.purchaseCompanyInfo = [];
      } else if (this.selectNameFlag === 'supplierCompanyIdList') {
        this.searchData.data.supplierCompanyIdList = null;
        this.queryData.supplierCompanyIdList = null;
        this.supplierCompanyInfo = [];
      }
      this.chooseVisible = false;
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.operatorOrderList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.operatorOrderList();
    },
    // 统一关闭弹框
    closeDialog() {
      this.orderDetailsVisible = false;
      this.orderOperationLogVisible = false;
      this.chooseVisible = false;
    },
    handleOrderDetails(row) {
      this.detailData.orderId = row.orderId;
      this.detailData.purchaseCompanyId = row.purchaseCompanyId;
      this.orderDetailsVisible = true;
    },
    // 操作日志
    handleOperationLog(row) {
      this.logData = {
        orderNo: row.orderNo,
        purchaseCompanyId: row.purchaseCompanyId,
      };
      this.orderOperationLogVisible = true;
    },
    handleFocus(obj) {
      console.log(obj, 'handleFocus');
      this.selectNameFlag = obj.item;
      if (this.selectNameFlag === 'purchaseCompanyIdList') {
        this.queryPurchaseCompanyVisible = true;
      } else {
        this.chooseVisible = true;
      }
    },
    handleFilter(val) {
      console.log(val);
      let orderStatusList = val.orderStatusList && val.orderStatusList.length > 0 ? val.orderStatusList : [];
      if (val.orderStatusList) {
        if (orderStatusList.includes(21)) {
          const arr = [22, 23];
          orderStatusList = val.orderStatusList.concat(arr);
        }
        if (orderStatusList.includes(31)) {
          orderStatusList.push(32);
        }
      }

      // 线下支付方式
      const underLine = [101, 102, 103, 104, 105];
      // 线上支付方式
      const online = [0, 1, 2, 3, 4];

      // isOnlinePay 在线支付 0 否 1 是
      if (underLine.includes(val.payment)) {
        this.queryData.isOnlinePay = 0;
      } else if (online.includes(val.payment)) {
        this.queryData.isOnlinePay = 1;
      } else {
        this.queryData.isOnlinePay = null;
      }

      this.queryData.orderNo = val.orderNo;
      this.queryData.orderStatusList = orderStatusList.length > 0 ? orderStatusList : null;
      this.queryData.memberRealName = val.memberRealName;
      this.queryData.startTime = val.submitTime ? val.submitTime[0] : null;
      this.queryData.endTime = val.submitTime ? val.submitTime[1] : null;
      this.queryData.systemSource = val.systemSource;
      this.queryData.invoiceNode = val.invoiceNode;
      this.queryData.isDoc = val.isDoc;
      this.queryData.payment = val.payment;
      this.queryData.invoiceMode = val.invoiceMode;
      this.queryData.orderSourceList = val.orderSourceList;
      this.queryData.electronicInvoiceFlag = val.electronicInvoiceFlag;
      this.queryData.startAmount = val.startAmount;
      this.queryData.endAmount = val.endAmount;
      this.queryData.purchaseCompanySource = val.purchaseCompanySource;
      this.queryData.pageNum = 1;

      this.operatorOrderList();
    },
    handleReset() {
      this.searchData.data.purchaseCompanyIdList = '';
      this.searchData.data.supplierCompanyIdList = '';
      this.companyIdList = [];
      this.purchaseCompanyInfo = [];
      this.supplierCompanyInfo = [];

      this.queryData = {
        purchaseCompanyIdList: null,
        orderNo: null,
        orderStatusList: null,
        memberRealName: null,
        supplierCompanyIdList: null,
        startTime: null,
        endTime: null,
        submitTime: null,
        systemSource: null,
        invoiceNode: null,
        isDoc: null,
        payment: null,
        invoiceMode: null,
        orderSourceList: null,
        isOnlinePay: null,
        startAmount: null,
        endAmount: null,
        purchaseCompanySource: null,
        pageNum: 1,
        pageSize: 10,
      };
      // 适配 易派客看板代码
      const epecKanBanParams = JSON.parse(localStorage.getItem('epecKanBanParams')) || {};
      if (Object.keys(epecKanBanParams).length > 0) {
        this.searchData.fieldList[0].disabled = true;
        const { companyId } = epecKanBanParams;
        this.queryData.purchaseCompanyIdList = [companyId];
      }
      this.operatorOrderList();
    },
    async operatorOrderList() {
      // 适配 易派客看板代码
      const epecKanBanParams = JSON.parse(localStorage.getItem('epecKanBanParams')) || {};
      if (Object.keys(epecKanBanParams).length > 0) {
        this.searchData.fieldList[0].disabled = true;
        const { companyId } = epecKanBanParams;
        this.queryData.purchaseCompanyIdList = [companyId];
      }

      const res = await api.operatorOrderList(this.queryData);
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;

        // 订单金额小计
        this.queryOrderTotalAmount();
      }
    },
    async queryOrderTotalAmount() {
      const res = await api.queryOrderTotalAmount(this.queryData);
      if (res.code === '200') {
        this.totalAmount = res.data || 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.split {
  height: 20px;
  background: #f0f0f0;
}
.flex-end {
  display: flex;
  justify-content: end;
  align-items: center;
}

.right-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-left: 4px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  font-size: 12px;
  color: #c5c5c5;
  cursor: pointer;
  &:hover {
    background: #c5c5c5;
    color: #fff;
  }
}
</style>
